import { c as _c } from "react/compiler-runtime";
import type { PreferencesClientMessage } from '@repo/map-preferences/types';
import type { MapInitializationData } from '@repo/types/maps/map-types';
import type { MutableRefObject } from 'react';
import { useFogOfWarLayer } from '../../fog-of-war/useFogOfWarLayer';
import { useFogOfWarSampler } from '../../fog-of-war/useFogOfWarSampler';
import { useHeatmapLayer } from './useHeatmapLayer/useHeatmapLayer';
import { useMapInitializer } from './useMapInitializer';
interface UseGameMapOptions {
  hasStoredPreferences?: boolean;
  syncSettled?: boolean;
  sendMessageRef?: MutableRefObject<((message: PreferencesClientMessage) => void) | null>;
}
export function useGameMap(providedMapData, options) {
  const $ = _c(16);
  const t0 = options?.hasStoredPreferences;
  const t1 = options?.syncSettled;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      hasStoredPreferences: t0,
      syncSettled: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const initializer = useMapInitializer(providedMapData, t2);
  const {
    fogRevealAtLatLng
  } = useFogOfWarSampler(options?.sendMessageRef);
  const {
    isFogLoginModalOpen,
    setIsFogLoginModalOpen,
    fogReady
  } = useFogOfWarLayer();
  useHeatmapLayer();
  let t3;
  if ($[3] !== fogReady || $[4] !== fogRevealAtLatLng || $[5] !== initializer.cleanUpFilterUrlParams || $[6] !== initializer.hoveredMarker || $[7] !== initializer.isMapInitialized || $[8] !== initializer.isPinLoginModalOpen || $[9] !== initializer.mapContainerRef || $[10] !== initializer.pendingUrlFilterState || $[11] !== initializer.popupDivRef || $[12] !== initializer.setIsPinLoginModalOpen || $[13] !== isFogLoginModalOpen || $[14] !== setIsFogLoginModalOpen) {
    t3 = {
      mapContainerRef: initializer.mapContainerRef,
      isMapInitialized: initializer.isMapInitialized,
      popupDivRef: initializer.popupDivRef,
      hoveredMarker: initializer.hoveredMarker,
      pendingUrlFilterState: initializer.pendingUrlFilterState,
      cleanUpFilterUrlParams: initializer.cleanUpFilterUrlParams,
      isPinLoginModalOpen: initializer.isPinLoginModalOpen,
      setIsPinLoginModalOpen: initializer.setIsPinLoginModalOpen,
      isFogLoginModalOpen,
      setIsFogLoginModalOpen,
      fogReady,
      fogRevealAtLatLng
    };
    $[3] = fogReady;
    $[4] = fogRevealAtLatLng;
    $[5] = initializer.cleanUpFilterUrlParams;
    $[6] = initializer.hoveredMarker;
    $[7] = initializer.isMapInitialized;
    $[8] = initializer.isPinLoginModalOpen;
    $[9] = initializer.mapContainerRef;
    $[10] = initializer.pendingUrlFilterState;
    $[11] = initializer.popupDivRef;
    $[12] = initializer.setIsPinLoginModalOpen;
    $[13] = isFogLoginModalOpen;
    $[14] = setIsFogLoginModalOpen;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}